import createStatusDropdownSelect from '@/components/statuses/factory/createStatusDropdownSelect';
import GENERAL_STATUSES from '@/components/statuses/GeneralStatus/options';

const GeneralStatusDropdownSelect = createStatusDropdownSelect({
  options: GENERAL_STATUSES,
  defaultSx: {
    '& .DropdownSelect-control': {
      borderColor: ({ palette }) => palette.grey[600],
      minHeight: ({ spacing }) => spacing(4)
    }
  },
  translationNamespace: 'filters'
});

export default GeneralStatusDropdownSelect;
